import { memo, useMemo } from 'react';

// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const filteredItems = useMemo(() => {
        try {
            const userStr = window.localStorage.getItem('xentai_user');
            const user = userStr ? JSON.parse(userStr) : null;
            // role 2 = vendor, only show reddit
            if (user?.role === 2) {
                return menuItem.items.filter((item) => item.id === 'reddit');
            }
        } catch {}
        return menuItem.items;
    }, []);

    const navItems = filteredItems.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default memo(MenuList);
